import { useEffect, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";
import api from "../api";

// Remembers the language someone actually reads the site in, so our emails arrive in it too.
export const LangSync = () => {
  const { user } = useAuth();
  const { lang } = useLang();
  const sent = useRef("");

  useEffect(() => {
    if (!user || !lang) return;
    const stamp = `${user.id}:${lang}`;
    if (sent.current === stamp || user.lang === lang) { sent.current = stamp; return; }
    sent.current = stamp;
    api.put("/my/lang", { lang }).catch(() => { sent.current = ""; });
  }, [user, lang]);

  return null;
};

export default LangSync;
